export const Get_Error = 'Get_Error';
//User or client
export const Get_All_users = 'Get_All_users';
export const Add_New_users = 'Add_New_users';
export const Delete_User = 'Delete_User';
export const Update_Client = 'Update_Client';
export const Get_One_Client = 'Get_One_Client';
export const Get_All_Top_Saler = 'Get_All_Top_Saler';
export const Get_All_Leads_For_Role_By_email_MarketerLeads_Type =
  'Get_All_Leads_For_Role_By_email_MarketerLeads_Type';
export const Get_All_users_Depending_on_Sales = 'Get_All_users_Depending_on_Sales';
export const SOCKET_NEW_LEAD = 'SOCKET_NEW_LEAD';
export const Assign_Leads_Admin_Marketer = 'Assign_Leads_Admin_Marketer';
export const Get_ALL_Stages_With_LeadsCount_For_Admin = 'Get_ALL_Stages_With_LeadsCount_For_Admin';
export const Get_ALL_Stages_With_LeadsCount_For_Marketer =
  'Get_ALL_Stages_With_LeadsCount_For_Marketer';
export const Get_ALL_Stages_With_LeadsCount_For_Marketer_CRM_DATA =
  'Get_ALL_Stages_With_LeadsCount_For_Marketer_CRM_DATA';

export const DashboardForManager_Type = 'DashboardForManager_Type';
export const DashboardForManager_CRMData_Type = 'DashboardForManager_CRMData_Type';
export const Get_All_Leads_For_Managers_By_Managers_Email_CRM_DATA =
  'Get_All_Leads_For_Managers_By_Managers_Email_CRM_DATA';

export const Get_All_Dublicates_Leads_For_Admin_Type = 'Get_All_Dublicates_Leads_For_Admin_Type';
export const recieveusertoleadtype = 'recieveusertoleadtype';
export const AssignleadinteamleaderType = 'AssignleadinteamleaderType';
export const Get_TeamLeader_Dashboard_Advanced_Type = 'Get_TeamLeader_Dashboard_Advanced_Type';
export const Get_sales_dashboard_Advanced = 'Get_sales_dashboard_Advanced';
export const SALES_LEADS_REPORT_SUCCESS = 'SALES_LEADS_REPORT_SUCCESS';
export const SALES_LEADS_REPORT_LOADING = 'SALES_LEADS_REPORT_LOADING';
export const Transfere_Leads_TO_Data_Center = 'Transfere_Leads_TO_Data_Center';
export const Get_TeamLeader_Dashboard_Advanced_crmdata_Type =
  'Get_TeamLeader_Dashboard_Advanced_crmdata_Type';


  export const SalesRequestData_Type = 'SalesRequestData_Type';
export const GetAll_SalesRequestData_Type = 'GetAll_SalesRequestData_Type';

//Developers
export const Add_Developers = 'Add_Developers';
export const Get_Developers = 'Get_Developers';
export const Delete_Developers = 'Delete_Developers';
export const Update_Developers = 'update_Developers';
export const Get_One_Developer = 'Get_One_Developer';

//Cities
export const Add_City = 'Add_City';
export const Get_All_Cities = 'Get_All_Cities';
export const Get_One_City_Data = 'Get_One_City_Data';
export const Update_One_City_data = 'Update_One_City_data';
export const Delete_One_City_data = 'Delete_One_City_data';

//Projects
export const Get_All_Projects = 'Get_All_Projects';
export const Add_Projects = 'Add_Projects';
export const Update_Project = 'Update_Project';
export const Get_One_Project_Data = 'Get_One_Project_Data';
export const Delete_One_Project_Data = 'Delete_One_Project_Data';
export const Get_Top_Projects_and_Analayse_For_Dashboard_Type = 'Get_Top_Projects_and_Analayse_For_Dashboard_Type';



//sales
export const Add_Sales = 'Add_Sales';
export const Get_All_Sales = 'Get_All_Sales';
export const Delete_One_Sales = 'Delete_One_Sales';
export const Get_One_Sales = 'Get_One_Sales';
export const Update_One_Sales = 'Update_One_Sales';
export const Get_All_Sales_By_TeamLeader_Email = 'Get_All_Sales_By_TeamLeader_Email';
export const Get_All_Sales_By_Managers_Email_Type = 'Get_All_Sales_By_Managers_Email_Type';
export const Get_All_Sales_Managers_By_Email = 'Get_All_Sales_Managers_By_Email';
export const Get_All_TeamLeaders_For_Managers_By_Email =
  'Get_All_TeamLeaders_For_Managers_By_Email';
export const Get_All_Managers = 'Get_All_Managers';
export const Get_All_Top_Saler_by_Quarter = 'Get_All_Top_Saler_by_Quarter';
export const Get_All_Top_Saler_by_monthyear = 'Get_All_Top_Saler_by_monthyear';
export const Get_All_Sales_For_Team_Leader_And_Teir_Leads =
  'Get_All_Sales_For_Team_Leader_And_Teir_Leads';
export const Get_All_Sales_Trash_type = 'Get_All_Sales_Trash_type';
export const Get_Sales_login_For_Assign_Leads_To_TeamLeaders_type =
  'Get_Sales_login_For_Assign_Leads_To_TeamLeaders_type';

//Auth
export const SignUp = 'SignUp';
export const login = 'Login';
export const Get_All_Users_log = 'Get_All_Users_log';
export const Get_All_Users_log_forsearch = 'Get_All_Users_log_forsearch';
export const Get_One_USer = 'Get_One_USer';
export const Update_One_USer_Main_Data = 'Update_One_USer_Main_Data';
export const Change_Password_Type = 'Change_Password_Type';
export const Get_All_Users_log_forsearch_not_active = 'Get_All_Users_log_forsearch_not_active';
export const Logout_All_Users_And_Deactivate_Except_Admins =
  'Logout_All_Users_And_Deactivate_Except_Admins';
export const LogOutselecteduser_Type = 'LogOutselecteduser_Type';

//Actions====>comments
export const GetAllActionsType = 'GetAllActionsType';
export const Add_Comment = 'Add_Comment';
export const GetAllActionsDataDashboardType = 'GetAllActionsDataDashboardType';
export const Delete_All_Action_For_One_Lead = 'Delete_All_Action_For_One_Lead';
export const Get_Action_With_Pages = 'Get_Action_With_Pages';
export const Insert_Comment_Replay = 'Insert_Comment_Replay';
export const Get_All_Selected_User_Comments = 'Get_All_Selected_User_Comments';
export const Update_Selected_Comment = 'Update_Selected_Comment';
export const Get_Last_200_Comment_For_Admin_Dashboard = 'Get_Last_200_Comment_For_Admin_Dashboard';

// meeting comments
export const AddMeetingComment_Type = 'AddMeetingComment_Type';

export const GetAllMeetingCommentsForoneuser_Type = 'GetAllMeetingCommentsForoneuser_Type';

export const GetAllMeetingCommentsByUser_Type = 'GetAllMeetingCommentsByUser_Type';
export const GetAllMettingsheetForAdmin_type = 'GetAllMettingsheetForAdmin_type';

//stage==>client
export const UpdateStage = 'UpdateStage';

//channals
export const Add_Channal = 'Add_Channal';
export const GetAll_Channal = 'GetAll_Channal';
export const delete_Channal = 'delete_Channal';
export const get_one_channal = 'get_one_channal';
export const update_one_channal = 'update_one_channal';

// Regions
export const Add_Regions = 'Add_Regions';
export const Get_All_Regions = 'Get_All_Regions';
export const Delete_one_Regions = 'Delete_one_Regions';
export const Update_one_Regions = 'Update_one_Regions';
export const Get_one_Regions = 'Get_one_Regions';

//Areas
export const Add_Area = 'Add_Area';
export const Get_All_Area = 'Get_All_Area';
export const Delete_Area = 'Delete_Area';
export const Get_One_Area = 'Get_One_Area';
export const Update_One_Area = 'Update_One_Area';

// communication way
export const AddCommunicationway = 'AddCommunicationway';
export const Get_All_Communicationway = 'Get_All_Communicationway';
export const Delete_One_Communicationway = 'Delete_one_Communicationway';
export const Get_One_Communicationway = 'Get_One_Communicationway';
export const Update_One_Communicationway = 'Update_One_Communicationway';

//stage type

export const Add_StageType = 'Add_StageType';
export const Get_All_StageType = 'Get_All_StageType';
export const Delete_StageType = 'Delete_StageType';
export const Get_One_StageType = 'Get_One_StageType';
export const Update_One_StageType = 'Update_One_StageType';

//stages

export const Add_Stages = 'Add_Stages';
export const Get_All_Stages = 'Get_All_Stages';
export const Delete_Stages = 'Delete_Stages';
export const Get_One_Stages = 'Get_One_Stages';
export const Update_One_Stages = 'Update_One_Stages';
export const Get_One_Stage_to_get_type = 'Get_One_Stage_to_get_type';

// cancel reasons
export const Add_CancelReasons = 'Add_CancelReasons';
export const Get_All_CancelReasons = 'Get_All_CancelReasons';
export const Delete_CancelReasons = 'Delete_CancelReasons';
export const Get_One_CancelReasons = 'Get_One_CancelReasons';
export const Update_One_CancelReasons = 'Update_One_CancelReasons';
export const Add_sales_Data_from_Excel = 'Add_sales_Data_from_Excel';

//user information data ---user activation
export const Add_user_information_data_activation = 'Add_user_information_data_activation';
export const Get_All_user_information_data_activation = 'Get_All_user_information_data_activation';
export const Add_User_Activation_LogOut_data = 'Add_User_Activation_LogOut_data';

// Lead Assigned
export const Add_Lead_Assigned_Type = 'Add_Lead_Assigned_Type';
export const Get_All_Lead_Assigned_Type = 'Get_All_Lead_Assigned_Type';
export const Delete_Lead_Assigned_Type = 'Delete_Lead_Assigned_Type';
export const Get_One_Lead_Assigned_Type = 'Get_One_Lead_Assigned_Type';
export const Update_One_Lead_Assigned_Type = 'Update_One_Lead_Assigned_Type';
export const Get_All_Leads_Selected_TO_Assign_Type = 'Get_All_Leads_Selected_TO_Assign_Type';

//leads Stages

export const Add_Leads_Stages_Type = 'Add_Leads_Stages_Type';
export const Get_All_Leads_Stages_Type = 'Get_All_Leads_Stages_Type';
export const Delete_Leads_Stages_Type = 'Delete_Leads_Stages_Type';
export const Get_One_Leads_Stages_Type = 'Get_One_Leads_Stages_Type';
export const Update_One_Leads_Stages_Type = 'Update_One_Leads_Stages_Type';

//Campaign
export const Add_Campaign_Type = 'Add_Campaign_Type';
export const Get_All_Campaign_Type = 'Get_All_Campaign_Type';
export const Delete_Campaign_Type = 'Delete_Campaign_Type';
export const Get_One_Campaign_Type = 'Get_One_Campaign_Type';
export const Update_One_Campaign_Type = 'Update_One_Campaign_Type';
export const Get_Campaign_Reports_Type = 'Get_Campaign_Reports_Type';

// Rotation
export const Add_Rotation_Type = 'Add_Rotation_Type';
export const Get_All_Rotation_Type = 'Get_All_Rotation_Type';
export const Get_One_Rotation_Type = 'Get_One_Rotation_Type';
export const Delete_One_Rotation_Type = 'Delete_One_Rotation_Type';
export const Update_One_Rotation_Type = 'Update_One_Rotation_Type';

// Data For Roles
export const Get_All_Team_Leaders = 'Get_All_Team_Leaders';
export const Get_All_Leads_For_Role_By_email_Type = 'Get_All_Leads_For_Role_By_email_Type';
export const Get_All_Leads_For_TeamLeader_By_TeamLeader_Email =
  'Get_All_Leads_For_TeamLeader_By_TeamLeader_Email';
export const Get_All_Leads_For_Managers_By_Managers_Email =
  'Get_All_Leads_For_Managers_By_Managers_Email';

// Markiting Reports
export const Get_Markiting_Reports_campaign = 'Get_Markiting_Reports_campaign';
export const Lead_Preview = 'Lead_Preview';
export const Important_Marketing_Reports_Type = 'Important_Marketing_Reports_Type';

// Accountant
export const Get_All_Leads_Done_Deal_Only = 'Get_All_Leads_Done_Deal_Only';
export const Get_Total_Sales_And_Total_Commission_In_All_Months =
  'Get_Total_Sales_And_Total_Commission_In_All_Months';

// Commissions
export const Add_New_Commission = 'Add_New_Commission';
export const Get_All_Leads_Commissions_For_Selected_Lead =
  'Get_All_Leads_Commissions_For_Selected_Lead';
export const Get_One_Commission_Type = 'Get_One_Commission_Type';
export const Update_Selected_Commisssion_Type = 'Update_Selected_Commisssion_Type';
export const Delete_Selected_Commission_Type = 'Delete_Selected_Commission_Type';

// Commissions Scheduals Dates
export const Add_New_Dates_For_Payment_Commission = 'Add_New_Dates_For_Payment_Commission';
export const Get_All_Schedual_Dates_Type = 'Get_All_Schedual_Dates_Type';
export const Delete_Selected_Schedual_Date = 'Delete_Selected_Schedual_Date';
export const Get_Selected_Schedual_Date = 'Get_Selected_Schedual_Date';
export const Update_Selected_Schedual_Date_Type = 'Update_Selected_Schedual_Date_Type';

// Commission Pay
export const Add_Commission_Pay_Type = 'Add_Commission_Pay_Type';
export const GetAll_Payments_For_Commission_Pay_Type = 'GetAll_Payments_For_Commission_Pay_Type';
export const Delete_Payment_Type = 'Delete_Payment_Type';
export const Update_Payment_Type = 'Update_Payment_Type';
export const Get_Developer_Statement_Type = 'Get_Developer_Statement_Type';

//Accountant Tasks
export const Add_Accountant_Tasks_Type = 'Add_Accountant_Tasks_Type';
export const Get_All_Accountant_Tasks = 'Get_All_Accountant_Tasks';
export const Get_Specific_Accountant_Task = 'Get_Specific_Accountant_Task';
export const Delete_Specific_Accountant_Task = 'Delete_Specific_Accountant_Task';
export const Update_Specififc_Account_Task = 'Update_Specififc_Account_Task';

//Company Profile
export const Add_CompanyProfile_Type = 'Add_CompanyProfile_Type';
export const Get_All_CompanyProfile_Type = 'Get_All_CompanyProfile_Type';
export const Get_Specific_CompanyProfile_Type = 'Get_Specific_CompanyProfile_Type';
export const Update_Specififc_CompanyProfile_Type = 'Update_Specififc_CompanyProfile_Type';

//Tasks
export const Add_New_Task = 'Add_New_Task';
export const Get_All_Tasks = 'Get_All_Tasks';
export const Get_Specific_Task = 'Get_Specific_Task';
export const Update_Specififc_Task = 'Update_Specififc_Task';

export const Get_All_Users_Devices = 'Get_All_Users_Devices';
export const logout_session_One_Device_Type = 'logout_session_One_Device_Type';

export const Get_All_Leads_For_Admin_Type = 'Get_All_Leads_For_Admin_Type';
export const Get_All_Leads_For_Sales_Type = 'Get_All_Leads_For_Sales_Type';





// company Domains
export const Add_Company_Domain = 'Add_Company_Domain';
export const Get_All_Company_Domain = 'Get_All_Company_Domain';
export const Get_One_Company_Domain = 'Get_One_Company_Domain';
export const Update_One_Company_Domain = 'Update_One_Company_Domain';